import { toast } from "react-toastify";

// Success Toast
export const showSuccessToast = (message:string) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "dark",
    style: { backgroundColor: "#333", color: "#fff", fontSize: "16px" },
  });
};

// Error Toast
export const showErrorToast = (message:string) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "dark",
    style: { backgroundColor: "#333", color: "#fff", fontSize: "16px" },
  });
};

// Info Toast
export const showInfoToast = (message:string) => {
  toast.info(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "dark",
    style: { backgroundColor: "#333", color: "#fff", fontSize: "16px" },
  });
};

// Warning Toast
export const showWarningToast = (message:string) => {
  toast.warning(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "dark",
    style: { backgroundColor: "#333", color: "#fff", fontSize: "16px" },
  });
};
